import { Popover } from "@mui/material";
import { PropsWithChildren } from "react";

interface PopoverProps  {
    id: string | undefined;
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    disableRestoreFocus?: boolean;
    sx?: any;
    transformOrigin?: any;
    anchorOrigin?: any;
}
export default function IntlPopover ({ id, anchorEl, children, open, onClose, disableRestoreFocus, sx, anchorOrigin, transformOrigin } : PropsWithChildren<PopoverProps>) {
    return <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
            ...anchorOrigin
        }}
        transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            ...transformOrigin
        }}
        sx={{
            '& .MuiPopover-paper' : {
                boxShadow: '0px 4px 28px 0px rgba(0, 0, 0, 0.08)'
            },
            ...sx
        }}
        disableRestoreFocus={disableRestoreFocus}
    >{ children }</Popover>
}